import React, { useMemo } from "react";
import { Icon } from "@iconify/react";
import "./ProductControls.css";
import MyGhostSelect from "./MyGhostSelect";

const ProductControls = ({
  sortOption,
  onSortOptionChange,
  onOpenSearch,
  selectedCategory1,
  selectedCategory2,
  selectedCategory3,
  onCategory1Change,
  onCategory2Change,
  onCategory3Change,
  onlyKorean,
  onToggleOnlyKorean,
  onlyPromo,
  onToggleOnlyPromo,
  products,

  // 🔴 추가된 props
  searchTerm,
  handleSearch,
}) => {
  // 정렬용 옵션 배열
  const sortOptions = [
    { value: "revenue", label: "💰 매출" },
    { value: "lastest_volume", label: "📦 수량" },
    { value: "volume_diff_today_yesterday", label: "📦 급등" },
  ];

  const category1Options = useMemo(
    () =>
      [...new Set(products.map((p) => p.first_level_category_name))]
        .filter(Boolean)
        .sort()
        .map((cat) => ({ value: cat, label: cat })),
    [products]
  );

  const category2Options = useMemo(
    () =>
      [...new Set(products.map((p) => p.second_level_category_name))]
        .filter(Boolean)
        .sort()
        .map((cat) => ({ value: cat, label: cat })),
    [products]
  );

  const category3Options = useMemo(
    () =>
      [...new Set(products.flatMap((p) => p.keywords?.split(",") || []))]
        .filter(Boolean)
        .sort()
        .map((cat) => ({ value: cat, label: cat })),
    [products]
  );

  return (
    <>
      {/* 상단 버튼 + 드롭다운 */}
      <div className="controls">
        {/* 검색 버튼 */}
        <button className="icon-btn" onClick={onOpenSearch} title="Search">
          <Icon icon="mdi:magnify" inline={true} />
        </button>

        {/* 정렬 GhostSelect */}
        <MyGhostSelect
          icon={<Icon icon="material-symbols:arrow-drop-down" inline={true} />}
          title="정렬"
          value={sortOption}
          onChange={onSortOptionChange}
          options={sortOptions}
          placeholder=""
        />

        {/* 대분류 */}
        <MyGhostSelect
          icon={<Icon icon="mdi:folder-outline" inline={true} />}
          title="대분류"
          value={selectedCategory1}
          onChange={onCategory1Change}
          options={category1Options}
        />

        {/* 중분류 */}
        <MyGhostSelect
          icon={<Icon icon="mdi:folder" inline={true} />}
          title="중분류"
          value={selectedCategory2}
          onChange={onCategory2Change}
          options={category2Options}
        />

        {/* 소분류 */}
        <MyGhostSelect
          icon={<Icon icon="mdi:file-document-outline" inline={true} />}
          title="소분류"
          value={selectedCategory3}
          onChange={onCategory3Change}
          options={category3Options}
        />

        {/* 한국 상품 토글 */}
        <button
          className={`icon-btn ${onlyKorean ? "active" : ""}`}
          onClick={onToggleOnlyKorean}
          title="한국 상품만"
        >
          <Icon icon="twemoji:flag-south-korea" inline={true} />
        </button>

        {/* 프로모션 상품 토글 */}
        <button
          className={`icon-btn ${onlyPromo ? "active" : ""}`}
          onClick={onToggleOnlyPromo}
          title="스토어 쿠폰"
        >
          <Icon icon="mdi:ticket-percent-outline" inline={true} />
        </button>
      </div>

      {/* 해시태그: 한 줄 아래 */}
      <div className="active-hashtags">
        {sortOption === "revenue" && <span>#매출</span>}
        {sortOption === "lastest_volume" && <span>#수량</span>}
        {sortOption === "volume_diff_today_yesterday" && <span>#급등</span>}

        {selectedCategory1 && (
          <button className="active-tag" onClick={() => onCategory1Change({ target: { value: "" } })} aria-label={`${selectedCategory1} 필터 제거`}>
            #{selectedCategory1} <Icon icon="material-symbols:close" inline={true} className="tag-close-icon" />
          </button>
        )}
        {selectedCategory2 && (
          <button className="active-tag" onClick={() => onCategory2Change({ target: { value: "" } })} aria-label={`${selectedCategory2} 필터 제거`}>
            #{selectedCategory2} <Icon icon="material-symbols:close" inline={true} className="tag-close-icon" />
          </button>
        )}
        {selectedCategory3 && (
          <button className="active-tag" onClick={() => onCategory3Change({ target: { value: "" } })} aria-label={`${selectedCategory3} 필터 제거`}>
            #{selectedCategory3} <Icon icon="material-symbols:close" inline={true} className="tag-close-icon" />
          </button>
        )}

        {searchTerm && (
          <button className="active-tag" onClick={() => handleSearch(searchTerm)} aria-label={`${searchTerm} 검색어 제거`}>
            #{searchTerm} <Icon icon="material-symbols:close" inline={true} className="tag-close-icon" />
          </button>
        )}

        {onlyKorean && (
          <button className="active-tag" onClick={() => onToggleOnlyKorean()} aria-label="한국 상품 필터 제거">
            #Korean <Icon icon="material-symbols:close" inline={true} className="tag-close-icon" />
          </button>
        )}
        {onlyPromo && (
          <button className="active-tag" onClick={() => onToggleOnlyPromo()} aria-label="프로모션 필터 제거">
            #Promo <Icon icon="material-symbols:close" inline={true} className="tag-close-icon" />
          </button>
        )}
      </div>
    </>
  );
};

export default ProductControls;
